import React, { useState, useEffect } from 'react';
import { CgMenuLeftAlt } from "react-icons/cg";
import Imagewebp from '../../components/Image_webp';
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { MdLogout } from "react-icons/md";
import '../layout/Sidebar.css';
import { FaArrowTurnDown, FaArrowTrendDown } from "react-icons/fa6";
import * as colors from "../../assets/css/Colors";
import { Link } from "react-router-dom";

const Header = () => {
	// Start color change auto function
    const [colorScheme, setColorScheme] = useState(
        window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    );
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            setColorScheme(e.matches ? 'dark' : 'light');
        };
        mediaQuery.addEventListener('change', handleChange);
        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);
    // End color change auto function

	// State for tracking active and open menus
	const [activeMenu, setActiveMenu] = useState('dashboard'); // Keeps track of which top-level menu is active
	const [openMenu, setOpenMenu] = useState('dashboard'); // Keeps track of which top-level menu is open
	const [activeSubMenu, setActiveSubMenu] = useState(null); // Tracks which submenu item is active
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	// Function to handle the general menu click (toggling the entire sidebar)
	const handleMenuClick = () => {
		setIsMenuOpen(!isMenuOpen);

		// Dispatch the custom event to toggle the menu on another page or component
		const event = new CustomEvent('toggleMenu', { detail: !isMenuOpen });
		window.dispatchEvent(event);
	};

	// Function to handle specific menu section click
	const handleMenuSectionClick = (menuName) => {
		if (openMenu === menuName) {
			setOpenMenu(''); // Close the currently open menu if clicked again
		} else {
			setOpenMenu(menuName); // Open the clicked menu
		}
		setActiveMenu(menuName); // Set the active top-level menu
	};

	// Function to handle submenu item click
	const handleSubMenuClick = (menuName, subMenuItem) => {
		setActiveSubMenu(subMenuItem); // Set the active submenu item
		setActiveMenu(menuName); // Keep the menu title active
	};

	  // Function to dynamically set the gradient styles
	  const styles = {
        background: colorScheme === 'dark' ? colors.theme_black_color_bg1 : colors.theme_white_color_bg1,
    };

	// Function to dynamically set the gradient styles
const getMenuTitleStyle = (menuName) => {
	if (activeMenu === menuName) {
	  return {
		background: colorScheme === 'dark' ? colors.theme_black_color_bg1 : colors.theme_white_color_bg1,
	  };
	}
	return {}; // No style if the menu isn't active
  };


	return (
		<>
			<section>
				<div className="ad-head">
					<div className="head-s1">
						<div className="logo">
							<Imagewebp text={'do-digital'} />
						</div>
						<div className="menu-icon" onClick={handleMenuClick}>
							<CgMenuLeftAlt />
						</div>
					</div>

					<div className="head-s3">
						<div className="head-pro">
							<Imagewebp text={'Do'} />
							<b>Profile by</b>
							<br></br>
							<h4>Bizbook Directory Template</h4>
							<a href="admin-setting.html" className="fclick"></a>
						</div>
					</div>
				</div>
			</section>
			<section>
				<div className={`ad-menu-lhs ${isMenuOpen ? '' : 'mshow'}`}>
					<div className="ad-menu">
						{/* Dashboard */}
						<div className="menu-item">
							<div
								className={`menu-title ${activeMenu === 'dashboard' ? 'active' : ''}`}
								onClick={() => handleMenuSectionClick('dashboard')} style={getMenuTitleStyle('dashboard')} // Conditional styling
							>
								<div>
								<MdOutlineDashboardCustomize className='title-icon-menu'/> Dashboard
								</div>
								<span className={`arrow ${openMenu === 'dashboard' ? 'down' : 'right'}`}>
								<FaArrowTurnDown className='down-arrow'/>
								<FaArrowTrendDown className='up-arrow'/>
								</span>
							</div>
							{openMenu === 'dashboard' && (
								<ul className="submenu">
									<li
										className={activeSubMenu === 'dashboardItem1' ? 'active' : ''}
										onClick={() => handleSubMenuClick('dashboard', 'dashboardItem1')}
									>
										<Link to="/">
										Item 1
										</Link>
									</li>
									<li
										className={activeSubMenu === 'dashboardItem2' ? 'active' : ''}
										onClick={() => handleSubMenuClick('dashboard', 'dashboardItem2')}
									>
										<Link to="/">
										Item 1
										</Link>
									</li>
									<li
										className={activeSubMenu === 'dashboardItem3' ? 'active' : ''}
										onClick={() => handleSubMenuClick('dashboard', 'dashboardItem3')}
									>
										<Link to="/">
										Item 1
										</Link>
									</li>
									<li
										className={activeSubMenu === 'dashboardItem4' ? 'active' : ''}
										onClick={() => handleSubMenuClick('dashboard', 'dashboardItem4')}
									>
										<Link to="/">
										Item 1
										</Link>
									</li>
								</ul>
							)}
						</div>

						{/* Menu 1 */}
						<div className="menu-item">
							<div
								className={`menu-title ${activeMenu === 'menu1' ? 'active' : ''}`}
								onClick={() => handleMenuSectionClick('menu1')}
								style={getMenuTitleStyle('menu1')} // Conditional styling
							>
								Menu 1
								<span className={`arrow ${openMenu === 'menu1' ? 'down' : 'right'}`}>
								<FaArrowTurnDown className='down-arrow'/>
								<FaArrowTrendDown className='up-arrow'/>
								</span>
							</div>
							{openMenu === 'menu1' && (
								<ul className="submenu">
									<li
										className={activeSubMenu === 'menu1Item1' ? 'active' : ''}
										onClick={() => handleSubMenuClick('menu1', 'menu1Item1')}
									>
										Menu 1 - Item 1
									</li>
									<li
										className={activeSubMenu === 'menu1Item2' ? 'active' : ''}
										onClick={() => handleSubMenuClick('menu1', 'menu1Item2')}
									>
										Menu 1 - Item 2
									</li>
								</ul>
							)}
						</div>

						{/* Additional Menus (same structure as above) */}
						<div className="menu-item">
							<div
								className={`menu-title ${activeMenu === 'menu2' ? 'active' : ''}`}
								onClick={() => handleMenuSectionClick('menu2')}
								style={getMenuTitleStyle('menu2')} // Conditional styling
							>
								Menu 2
								<span className={`arrow ${openMenu === 'menu2' ? 'down' : 'right'}`}>
								<FaArrowTurnDown className='down-arrow'/>
								<FaArrowTrendDown className='up-arrow'/>
								</span>
							</div>
							{openMenu === 'menu2' && (
								<ul className="submenu">
									<li
										className={activeSubMenu === 'menu2Item1' ? 'active' : ''}
										onClick={() => handleSubMenuClick('menu2', 'menu2Item1')}
									>
										Menu 2 - Item 1
									</li>
									<li
										className={activeSubMenu === 'menu2Item2' ? 'active' : ''}
										onClick={() => handleSubMenuClick('menu2', 'menu2Item2')}
									>
										Menu 2 - Item 2
									</li>
								</ul>
							)}
						</div>
						<ul>
							<li> <a href="profile.html" className="mact">
								<MdOutlineDashboardCustomize /> Dashboard</a>
							</li>
							<li> <a href="logout.html"> <MdLogout /> Log out</a>
							</li>
						</ul>
					</div>
				</div>
			</section>
		</>
	)
}

export default Header